import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DeliveryDeviceService } from 'app/services/models/delivery-device.service';
import { ProductService } from 'app/services/models/product.service';
import { TransactionProductService } from 'app/services/models/transaction-product.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-delivery-device-transaction-product',
  templateUrl: './delivery-device-transaction-product.component.html',
  styleUrls: ['./delivery-device-transaction-product.component.scss']
})
export class DeliveryDeviceTransactionProductComponent implements OnInit {
  @Input() data: { id?: number, deviceId: number, deviceName,brand,brandModel,kind,seriNo, offerId: number, kindId: number };
  constructor(
    private transactionProductService: TransactionProductService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private productService: ProductService,
    private deliveryDeviceService: DeliveryDeviceService,
    private toastrService: ToastrService
  ) { }

  deliveryDeviceForm: FormGroup;
  deliveryDevice: any = {};
  transactionProducts: any[] = [];

  async ngOnInit() {
    this.deliveryDeviceForm = this.fb.group({
      productId: [null, Validators.required], // Tek firma seçimi
    });
    if (this.data.offerId != null) {
      await this.getAllTransactionProducts(this.data.offerId, this.data.kindId);
    }
    else {
      await this.getAllProducts(this.data.kindId);
    }

    if (this.data.id) {
      await this.getByIdDeliveryDevice(this.data.id);
    }
  }

  async getAllTransactionProducts(offerId, kindId) {
    const data = await this.transactionProductService.transactionManagementTransactionProductsById(offerId, kindId);
    console.log(data);
    this.transactionProducts = data;
    if(this.transactionProducts){
      this.toastrService.error('Cihaz türü ile teklif kalemi eşleşen tür yok. İsterseniz genel kalemlerden seçin');
      await this.getAllProducts(this.data.kindId);
    }
  }

  async getAllProducts(kindId) {
    const data = await this.productService.getAllProducts(0, 1000, '', null, null, null, null, null, null, kindId);
    this.transactionProducts = data.products.map(product => ({
      ...product,
      productId: product.id
    }));
    console.log(this.transactionProducts);

  }

  closeModal() {
    this.activeModal.close(false);
  }

  saveDeliveryDevice() {
    if (this.deliveryDeviceForm.invalid) {
      return;
    }
    let product;
    console.log(this.deliveryDeviceForm.value);

    product = this.transactionProducts.find(p => p.productId == this.deliveryDeviceForm.value.productId);

    console.log(product);
    const formData = {
      productId: this.deliveryDeviceForm.value.productId,
      deviceId: this.data.deviceId,
      name: product?.name
    };

    // Backend'e gönderim işlemi yapılabilir
    this.activeModal.close(formData); // Modal'ı kapat
  }

  async getByIdDeliveryDevice(id) {
    const data = await this.deliveryDeviceService.getByIdDeliveryDevice(id);
    console.log(data);
    this.deliveryDevice = data;
    this.deliveryDeviceForm.patchValue({
      productId: this.deliveryDevice.productId
    })
  }

  async onUpdateSave() {

    const data = await this.deliveryDeviceService.updateDeliveryDevice({
      id: this.deliveryDevice.id,
      companyId: this.deliveryDevice.companyId,
      deliveryCompanyPersonId: this.deliveryDevice.deliveryCompanyPersonId,
      deliveryDate: this.deliveryDevice.deliveryDate,
      deliveryId: this.deliveryDevice.deliveryId,
      deliveryMethodId: this.deliveryDevice.deliveryMethodId,
      deliveryPerson: this.deliveryDevice.deliveryPerson,
      deviceAcceptanceStatesId: this.deliveryDevice.deviceAcceptanceStatesId,
      deviceId: this.deliveryDevice.deviceId,
      isDeliveryStatus: false,
      personId: this.deliveryDevice.personId,
      productId: this.deliveryDeviceForm.value.productId
    });
    if (data.status) {
      this.deliveryDeviceService.sendEvent(true);
      this.toastrService.success(data.message);
      this.closeModal();
    } else {
      this.toastrService.error(data.message);
    }
  }
}
